import React, { useCallback } from 'react';

import { COMPANY_INFO_FIELDS } from '../../common/fields';
import * as actions from '../../containers/General/generalActions';

import TextInput from '../Controls/TextInput/TextInput';
import ImageUpload from '../Controls/ImageUpload/ImageUpload';
import Account from '../Controls/Account/Account';
import AdaptiveBlock from '../Controls/AdaptiveBlock/AdaptiveBlock';

import CopyButton from '../Controls/CopyButton/CopyButton';
import { SettingsFeatureLock } from '../LockedFeatures/SettingsFeatureLock';

const CompanyInfo = ({ fields, dispatch }) => {
    const companyName = fields[COMPANY_INFO_FIELDS.COMPANY_NAME.ID];
    const companyLogo = fields[COMPANY_INFO_FIELDS.COMPANY_LOGO.ID];
    const companySupportEmail = fields[COMPANY_INFO_FIELDS.COMPANY_SUPPORT_EMAIL.ID];
    const snmpAccount = fields[COMPANY_INFO_FIELDS.SNMP_ACCOUNT.ID];
    const cleanAuthLogs = fields[COMPANY_INFO_FIELDS.CLEAN_AUTH_LOGS.ID];
    const windowsLogonToken = fields[COMPANY_INFO_FIELDS.WINDOWS_LOGON_TOKEN.ID];
    const mfaThreshold = fields[COMPANY_INFO_FIELDS.AUTO_DENY_MFA_THRESHOLD.ID];
    const mfaWindowSize = fields[COMPANY_INFO_FIELDS.AUTO_DENY_MFA_WINDOW_SIZE.ID];
    const authLogsThreshold = fields[COMPANY_INFO_FIELDS.MAX_AUTH_AGG_THRESHOLD.ID];

    const dispatchUpdate = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.UPDATE_COMPANY_INFO,
                payload: { fieldId, value }
            });
        },
        [dispatch]
    );

    return (
        <>
            {companyName && <TextInput field={companyName} changed={dispatchUpdate} />}
            {companyLogo && <ImageUpload field={companyLogo} changed={dispatchUpdate} />}
            {companySupportEmail && (
                <TextInput field={companySupportEmail} placeholder="support@mycompany.com" changed={dispatchUpdate} />
            )}
            {snmpAccount && (
                <Account
                    field={snmpAccount}
                    changed={dispatchUpdate}
                    header={
                        'Enter a password, at least 8 characters in length, composed of letters, digits, and special characters.'
                    }
                    validatePassword
                />
            )}
            {windowsLogonToken && (
                <TextInput
                    type="password"
                    disabled
                    field={windowsLogonToken}
                    changed={dispatchUpdate}
                    featureLockId={COMPANY_INFO_FIELDS.WINDOWS_LOGON_TOKEN.ID}>
                    <SettingsFeatureLock id={COMPANY_INFO_FIELDS.WINDOWS_LOGON_TOKEN.ID}>
                        <CopyButton value={windowsLogonToken.value} />
                    </SettingsFeatureLock>
                </TextInput>
            )}
            {cleanAuthLogs && <TextInput field={cleanAuthLogs} changed={dispatchUpdate} />}
            {authLogsThreshold && <TextInput field={authLogsThreshold} changed={dispatchUpdate} />}
            {mfaThreshold && mfaWindowSize && (
                <AdaptiveBlock mfaThreshold={mfaThreshold} mfaWindowSize={mfaWindowSize} changed={dispatchUpdate} />
            )}
        </>
    );
};

export default React.memo(CompanyInfo);
